import axios from 'axios'

function readFileAsync(file) {
    return new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.onload = function () {
            resolve(reader.result);
        };

        reader.onerror = function (err) {
            console.error("An error occurred.");
            reject(err);
        };

        reader.readAsArrayBuffer(file);
    })
}

async function getSignedRequest(fileName, fileType) {
    return await axios.get(`${process.env.VUE_APP_FORMS_ENDPOINT}/get-signed-url?file-name=${fileName}&file-type=${fileType}`)
}

async function putToS3(signedRequest, file, type) {
    return await axios.put(signedRequest, file, {
        headers: {
            'Content-Type': type
        }
    })
}

async function uploadFile(fileObj) {
    const file = await readFileAsync(fileObj);
    const {data} = await getSignedRequest(fileObj.name, fileObj.type);
    await putToS3(data.signedRequest, file, fileObj.type);
    return {
        key: data.key,
        name: fileObj.name,
        url: data.url
    }
}

async function upload(formData) {
    const docs = formData.getAll('documents');
    const uploads = docs.map(uploadFile);
    return Promise.all(uploads);
}

export {upload, uploadFile}
